<!-- eslint-disable -->
<template lang="pug">
    .progress-detective-wrapper(v-if="user.type === 'student'")
        template(v-if='!isButtonLoading')
            div
                template(v-if='points < itemPrice')
                    | {{ $i18n.t('detective.detective_progress_to_new_item') }}
                span.next-item-button(v-else='' @click="$emit('buyNextItem')")
                    | {{ $i18n.t('detective.detective_progress_enough') }}
            progress.progress.is-info(
                :class=`{
                    'animate': isAllowedToAnimate,
                    'next-item-button': points >= itemPrice
                }`,
                :value='points',
                :max='itemPrice',
                @click="points >= itemPrice && $emit('buyNextItem')"
            )
            span.progress-text(v-if='points < itemPrice')
                | {{ points }} {{ $i18n.t('detective.detective_progress_of') }} {{ itemPrice }}
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
  import { mapState } from 'vuex';

  export default {
      props: {
          points: Number,
          itemPrice: Number,
      },
      computed: {
          ...mapState({
              user: state => state.auth.user
          }),
          isAllowedToAnimate () {
              return this.points >= this.itemPrice;
          }
      },
      data () {
          return {
              isButtonLoading: false
          }
      },
      watch: {
          '$route.name': {
              handler () {
                  this.isButtonLoading = false;
              },
              immediate: true
          }
      },
  }
</script>

<style lang="scss">
    @import "@/assets/sass/detective/progress.scss";
</style>
